import { render, staticRenderFns } from "./XhCertificateEdit2.vue?vue&type=template&id=ba5fbbea&scoped=true"
import script from "./XhCertificateEdit2.vue?vue&type=script&lang=js"
export * from "./XhCertificateEdit2.vue?vue&type=script&lang=js"
import style0 from "./XhCertificateEdit2.vue?vue&type=style&index=0&id=ba5fbbea&prod&lang=scss&scoped=true"
import style1 from "./XhCertificateEdit2.vue?vue&type=style&index=1&id=ba5fbbea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5fbbea",
  null
  
)

export default component.exports